// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff67122f","389":"9df9cc96","453":"b70063e9","732":"c48f2193","977":"2cc5c052"}[chunkId] + ".chunk.js";
};